import { CatButton } from '@blocks-react/components/Button';
import { ViewAllButtonProps } from '../types';
import { useBreakpoint } from '../../../../hooks';
import { PAGE_BREAKPOINTS } from '../../../../constants/commonConstants';
export const BestSellerViewAll = ({
  children,
  ...buttonProps
}: ViewAllButtonProps) => {
  const isMD = useBreakpoint(PAGE_BREAKPOINTS.MD);
  return (
    <CatButton
      variant="contrast"
      fullWidth={!isMD}
      type="button"
      {...buttonProps}
    >
      {children}
    </CatButton>
  );
};
